import React from 'react';

import { Badge } from 'shadcn/components/ui/Badge';

/**
 * Renders the status cell content for a packaging purchase order row.
 *
 * @param {Object} props - Component props.
 * @param {string | null | undefined} props.status - Raw status value from the table row.
 * @param {string} [props.fallbackText='—'] - Fallback text when no status is available.
 * @returns {JSX.Element | null} Status cell JSX.
 */
export function PackagingPOStatusCell({ fallbackText = '—', status }) {
    const statusValue = String(status || fallbackText);
    const normalizedStatus = statusValue.toUpperCase();

    const statusBadgeClassName = (() => {
        if (normalizedStatus === 'CONSUMED') {
            return 'bg-sky-600 text-white border-sky-700 hover:bg-sky-600 hover:text-white';
        }
        if (normalizedStatus === 'CANCELLED') {
            return 'bg-slate-200 text-slate-800 border-slate-300 hover:bg-slate-200 hover:text-slate-800';
        }
        return 'bg-sky-100 text-sky-900 border-sky-200 hover:bg-sky-100 hover:text-sky-900';
    })();

    return (
        <Badge variant="outline" className={statusBadgeClassName}>
            {statusValue}
        </Badge>
    );
}

PackagingPOStatusCell.displayName = 'PackagingPOStatusCell';
